// Plain-English guidance shown in the "i" hover hints next to each credential field.
export const HINTS = {
  square_app_id:
    "Square Developer Dashboard → Applications → open your app → set the top toggle to Sandbox → Credentials. Copy the 'Sandbox Application ID' (starts with sandbox-sq0idb-…). For live sellers, switch the toggle to Production (starts with sq0idp-…).",
  square_location_id:
    "Square Developer Dashboard → your app → Credentials, or the Seller Dashboard → Settings → Locations. It starts with 'L…'. Tip: using 'Connect with Square' fills this in automatically.",
  square_access_token:
    "Square Developer Dashboard → your app → Credentials (with the toggle on Sandbox) → 'Sandbox Access token' (starts with EAAAl…). Keep it secret — never put it in front-end code. We store it encrypted.",
  square_env:
    "Use Sandbox with sandbox credentials (test cards, no real money). Use Production with live credentials to take real charges.",
  stripe_secret:
    "Stripe Dashboard → Developers → API keys → 'Secret key' (sk_test_… or sk_live_…). Keep it secret; we store it encrypted. Or just keep the built-in test key toggle on above.",
  stripe_pub:
    "Stripe Dashboard → Developers → API keys → 'Publishable key' (pk_test_… / pk_live_…). This one is safe to expose — it builds the card form on your front-end.",
};
